module.exports = __webpack_public_path__ + "img/linkedin.0580fd1.svg";